import { useEffect, useRef, useState } from "react";
import { ProductsViewModel } from "../../viewmodels/products/ProductsViewModel";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import {
  classNames,
  convertProductStatus,
  convertStockStatusToPill,
  withRouter,
} from "../../shared/utility";

import { Link } from "react-router-dom";

import SlideOver from "../../components/slideOver/SlideOver";
import EmptyModal from "../../components/modals/EmptyModal";
import FilterDropdown from "../../components/filterDropdown/FilterDropdown";

import { Paginator } from "primereact/paginator";
import SimpleNotification from "../../components/SimpleNotification";
import Pills from "../../components/controls/Pills";

function Products(props) {
  const { logout } = props;
  const {
    emptyModal,
    setEmptyModelOpen,
    getProducts,
    loading,
    products,
    setSlideOver,
    setShowSimpleNotification,
    slideOver,
    showSimpleNotification,
    filterComponents,
    resetFilters,
    showFilters,
    setShowFilters,
    filters,
    getPrimaryCategoriesForDropdown,
    getSubCategoriesForDropdownByPrimary,
    resetSubCategoryFilter,
  } = ProductsViewModel(logout);

  var currentPage = 1;
  useEffect(() => {
    getProducts(null, currentPage, filters);
    getPrimaryCategoriesForDropdown();
  }, []);

  useEffect(() => {
    resetSubCategoryFilter();
    if (filters.primaryCategory.value > 0) {
      getSubCategoriesForDropdownByPrimary(filters.primaryCategory.value);
    }
  }, [filters.primaryCategory]);

  const [first, setFirst] = useState(1);
  const [rows, setRows] = useState(20);

  const searchRef = useRef();

  const handleSearch = () => {
    getProducts(searchRef.current.value, currentPage, filters);
  };

  const handlePagination = (event) => {
    currentPage = event.page + 1;
    setFirst(event.first);
    setRows(event.rows);
    getProducts(searchRef.current.value, currentPage, filters);
  };

  return (
    <div>
      <div className="mt-2">
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="sm:flex sm:items-center px-4 py-5 sm:px-4 card-custom">
            <div className="sm:flex-auto">
              <h1 className="text-base font-semibold leading-6 text-gray-900">
                Products
              </h1>
              <div className="mt-5 flex rounded-md">
                <div className="relative flex items-stretch flex-grow focus-within:z-10">
                  <input
                    type="search"
                    name="searchProduct"
                    id="searchProduct"
                    className="block w-full rounded-lg rounded-l-md pl-2 sm:text-sm border border-gray-300 rounded-tr-none rounded-br-none"
                    placeholder="Search by product name"
                    ref={searchRef}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") handleSearch();
                    }}
                  />
                  <button
                    type="button"
                    className="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1"
                    onClick={() => handleSearch()}
                  >
                    <MagnifyingGlassIcon
                      className="h-5 w-5 text-gray-400"
                      aria-hidden="true"
                    />
                  </button>
                </div>
                <FilterDropdown
                  actionCall={() =>
                    getProducts(searchRef.current.value, currentPage, filters)
                  }
                  filterComponents={filterComponents}
                  resetFilters={() => {
                    resetFilters();
                  }}
                  showFilters={showFilters}
                  setShowFilters={setShowFilters}
                />
              </div>
            </div>
          </div>
          <div className="mt-8 flow-root">
            <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                {loading ? (
                  <div>
                    <div className="border h-10 shadow rounded-md p-4 w-full mx-auto">
                      <div className="animate-pulse flex space-x-4">
                        Loading
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="overflow-hidden card-custom">
                    <table className="min-w-full divide-y divide-gray-300">
                      <thead className="bg-white">
                        <tr>
                          <th
                            scope="col"
                            className="py-3 pl-3 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                          >
                            Name
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 text-start"
                          >
                            Description
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 text-start"
                          >
                            Category
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 text-end"
                          >
                            Inventory
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 text-end"
                          >
                            Reorder point
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 text-start"
                          >
                            Taxable
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 text-end"
                          >
                            Price
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 text-center"
                          >
                            Stock Status
                          </th>
                          <th
                            scope="col"
                            className="relative py-3.5 pl-3 pr-4 sm:pr-6"
                          ></th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-200 bg-white">
                        {products.data.map((product, index) => (
                          <tr
                            key={product.id}
                            // className={classNames(
                            //   parseFloat(product.stock) <
                            //     parseFloat(product.low_stock_threshold)
                            //     ? "bg-red-50"
                            //     : null
                            // )}
                          >
                            <td className="whitespace-nowrap py-3 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                              {product.name} <br />
                              {product.plu}
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-start">
                              {product.description}
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-start">
                              {product.primary_category_name}
                              {product.sub_category_name ? (
                                <span> / {product.sub_category_name}</span>
                              ) : null}
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-end">
                              {product.stock}
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-end">
                              {product.low_stock_threshold}
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-end">
                              {product.taxable === 1 ? "Yes" : "No"}
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-end">
                              {product.unit_price}
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center">
                              <Pills
                                content={convertStockStatusToPill(
                                  product.stock,
                                  product.low_stock_threshold
                                )}
                              />
                            </td>
                            <td className="relative whitespace-nowrap py-3 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                              <Link
                                className="ml-5 rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                to={"/products/" + product.id}
                              >
                                View
                              </Link>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
              <div className="w-full">
                <Paginator
                  first={first}
                  rows={rows}
                  totalRecords={products.total}
                  onPageChange={handlePagination}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
      <SlideOver
        childComponent={slideOver.childComponent}
        slideOver={slideOver}
        setSlideOver={setSlideOver}
      />
      <SimpleNotification
        setShow={setShowSimpleNotification}
        showSimpleNotification={showSimpleNotification}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Products)
);
